import React, { useState, useEffect } from "react";
import { Box, Grid, Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";
import classes from "../../controls.module.scss";
import { CheckIsUserAdmin } from "../../../../Shared/Utill/Utills";
import { NavLink, useLocation } from "react-router-dom";
import { AddPlusIcon } from "../../../../Resources/availabilityicon/IconUtils";
import axios from "axios";
import axiosInstance from "../../../../Shared/Utill/AxiosConfig";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { constants } from "../../../../Shared/Url/Constants";
import {
    FormControl,
    TextField,
    Button,

} from '@mui/material';
import AdminControlsDataGrid from '../../AdminControlsDataGrid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Dialog, useToggle } from '@genesis/ui-kit';
import SnackBar from "../../../../Shared/Snackbar/Snackbar";
import { isString } from '../../../../Shared/Utill/Utills';
import {AllControlSearchView} from "../RuleAssignments/Search/RuleAssignmentsSearch"

const WorkScheduleGrouping = () => {
    const navigate = useNavigate();
    const [workSchedule, setWorkSchedule] = useState("");
    const [groupId, setGroupId] = useState("");
    const [searchValue, setSearchValue] = useState([]);
    const personDetails = useSelector((state) => state.person.personData);
    const token = Cookies.get('X_TKN');
    const urlDetails = useSelector((state) => state.url.urlData);
    const history = useNavigate();
    const dialog = useToggle();
    const [deleteId, setDeleteId] = useState("");
    const [deleteName, setDeleteName] = useState("");
    const [isAlertOpen, setAlertOpen] = React.useState({});
    const { message, severity, open } = isAlertOpen || {};
    const deleteLocation = useLocation();

    CheckIsUserAdmin();

    useEffect(() => {
        if(deleteLocation.state !== null && deleteLocation.state === "DeleteLocation"){
          setAlertOpen({
            open: true,
            severity: "success",
            message: "Work Schedule deleted successfully.",
        })
        }
    
      }, []);

    // colums to show

    const columns = [
        { field: 'workschedule', headerName: 'Work Schedule', width: "350" },
        { field: 'groupid', headerName: 'Group ID', width: "200" },
        {
            field: 'actions', headerName: 'Actions', width: "120", disableColumnMenu:true, renderCell: (params) => {
                console.log("edit details", params.row)
                return (<div>
                    <NavLink
                        to="Edit"
                        style={{ textDecoration: "underline" }}
                        state={{ flag: "E", id: params.row.id, isSearch: true }}
                        className={classes.label_text}>
                        <EditIcon />
                    </NavLink> <DeleteOutlineIcon onClick={() => showDeleteDialog(params.row.id, params.row.workschedule)} />
                </div>)

            }
        },

    ];

    const handleAlertNotifClose = () => {
        setAlertOpen({});
     };
   

    const showDeleteDialog = (id, name) => {
        setDeleteId(id);
        setDeleteName(name);
        dialog.show()
    }

    const deleteWorkSchedule = () => {

        axiosInstance.delete(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAILABILITY_WORK_SCHEDULE_DELETE_BY_WSID}/${deleteId}`, {
            headers: {
                'content-type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then((res) => {
            dialog.hide();
            setAlertOpen({
                open: true,
                severity: "success",
                message: "Work Schedule deleted successfully.",
            })
            handleSearch()
        }).catch((err) => {

        });
    }

    const handleSearch = () => {
        // data for searching
        let data = {
            workSchedule: workSchedule,
            groupId: groupId,
            lastUpdatedBy: personDetails.emplID
        }

        if(isString(groupId)) {
            setAlertOpen({
                open: true,
                severity: "error",
                message: "Group ID should be numeric.",
            })

        } else {

        axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVAILABILITY_WORK_SCHEDULE_ADMIN_SEARCH}`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token,
                }
            }).then((res) => {

                let tmparr = []
                //console.log("response",res.data);
                res.data.map(obj => {
                    let tmpobj = {}
                    tmpobj.id = obj.wsId;
                    tmpobj.workschedule = obj.workSchedule;
                    tmpobj.groupid = obj.groupId;
                    tmparr.push(tmpobj);

                });
                setSearchValue(tmparr);
                //console.log(tmparr)
            }).catch((err) => {
                if (err.message === 'Network Error') {
                    history("/somethingwentwrong", { state: `Please logout and try again ` })
                } else {
                    history("/somethingwentwrong", { state: `${constants.WFM_EVENT_CONTROL_GET_EVENT_DETAILS_ON_SEARCH_EVENT}...failed` })
                }
            });
        }

        /* let res  = [{"wsId":1,"workSchedule":"MY_FT_OPT_20_30_ALL_MA8","groupId":2}, {"wsId":2,"workSchedule":"MY_FT_OPT_20_30_ALL_MA8_123","groupId":2}]
        let tmparr = []
      
        res.map(obj => {
            let tmpobj = {}
            tmpobj.id = obj.wsId;
            tmpobj.workSchedule = obj.workSchedule;
            tmpobj.groupid = obj.groupId;
            tmparr.push(tmpobj);
        }); */
        //setSearchApiValue(res.data);
        //setSearchValue(tmparr);
    }

    return (
        <div className={classes.pagemargin}>
            <AllControlSearchView />
            <div className={classes.pagetitle} >Work Schedule Grouping </div>
            <Box>
                <Dialog
                    open={dialog.open}
                    title={'Delete Work Schedule'}
                    onClose={dialog.hide}

                    actions={
                        <>
                            <>
                                <Button color="secondary" onClick={dialog.hide}>No</Button>
                                <Button onClick={deleteWorkSchedule}>Yes</Button>
                            </>
                        </>
                    }

                >
                    <Typography>Are you sure you want to delete this work schedule {deleteName} across all divisions?</Typography>

                </Dialog>
            </Box>

            <SnackBar
                open={open}
                message={message}
                severity={severity}
                onClose={handleAlertNotifClose}
            ></SnackBar>
            <div className={classes.icon_text_wrap}>
                <div className={classes.icon_text}>
                    <AddPlusIcon />&nbsp;
                    <NavLink
                        to="Add"
                        style={{ textDecoration: "underline" }}
                        state={{ flag: "A", isSearch: true }}
                        className={classes.label_text}>
                        Add
                    </NavLink>
                </div>
            </div>
            <div className={classes.searchbox}>


                <Grid container spacing={3}>
                    <Grid key={0} item xs={6}>
                        <FormControl style={{ minWidth: '100%' }}>
                            <TextField
                                label="Work Schedule (Opt)"
                                onChange={(e) => setWorkSchedule(e.target.value)}
                                value={workSchedule}
                            />
                        </FormControl>
                    </Grid>
                    <Grid key={1} item xs={2}>
                        <FormControl style={{ minWidth: '100%' }}>
                            <TextField
                                label="Group ID (Opt)"
                                onChange={(e) => setGroupId(e.target.value)}
                                value={groupId}
                            />
                        </FormControl>
                    </Grid>


                    <Grid key={2} item xs={4}>
                        <Button style={{
                            marginLeft: "10px",
                            paddingTop: "14px",
                            paddingBottom: "14px",
                            paddingLeft: "80px",
                            paddingRight: "80px",
                            marginRight: "5px"
                        }} onClick={handleSearch}>Search</Button>
                    </Grid>
                </Grid>

            </div>
            <AdminControlsDataGrid columns={columns} rows={searchValue} width={"90%"} />
        </div>


    );

}

export default WorkScheduleGrouping;